import NotificationService from "@/services/notification.js";

const state = {
    count: 0 // badge
};

const actions = {
    async getNotificationCount(store, payload = {}) {
        let res = await NotificationService.getNotificationCount({
            socket: payload.socket || false
        });

        store.dispatch(
            "updateBadgeCountByArray",
            res?.data?.response?.resources ?? []
        );
    },
    updateBadgeCountByArray(store, arr = []) {
        let userPrefs = store.rootGetters["userPreferences/prefs"]; // access the `userPreferences` module (vuex) to get preferences.
        let notificationPrefs = userPrefs?.notification ?? [];

        if (!Array.isArray(notificationPrefs)) {
            notificationPrefs = [];
        }

        let badgeCount = 0;

        for (let rec of arr) {
            let pref = notificationPrefs.find(n => n.type === rec.type);
            if (pref && pref.show_badge) {
                badgeCount += rec.count;
            }
        }

        store.commit("setCount", badgeCount);
    }
};

const mutations = {
    setCount(state, value) {
        state.count = value;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
